<template lang="pug">
  #freights-tracking.center-panel.md-scrollbar.md-theme-default
    .md-layout-row.heading
      h1.md-title(v-if="title") {{ (freight.traking_number) ? title + ' ' + freight.traking_number : title }}
    md-content.md-elevation-1(md-theme="white")
      .md-flex(md-theme="white")
        md-content.freight-description
        sort-table(v-bind:columns="tableColumns" v-model="tracking" @refresh="getFreightTracking" v-bind:per-page="perPage" v-bind:total="trackingAmount")
          template(slot="stock.name" slot-scope="scope") {{ scope.item.stock.name }}
          template(slot="responsible.login" slot-scope="scope") {{ scope.item.responsible.login }}
        //- md-table(md-theme="white" v-model="freight.traking" md-sort="id" md-sort-order="asc")
        //-   md-table-row(slot="md-table-row"  slot-scope="{item}")
        //-     md-table-cell(md-sort-by="id"              md-label="ID склада"               ) {{item.stock.id}}
        //-     md-table-cell(md-sort-by="stock.name"      md-label="Склад"       ) {{item.stock.name}}
        //-     md-table-cell(md-sort-by="responsible.login" md-label="Ответственный"  ) {{item.responsible.login}}
        //-     md-table-cell(md-sort-by="arrival"           md-label="Прибыл"         ) {{(item.arrival == 1) ? 'Да' : 'Нет'}}
        //-     md-table-cell(md-sort-by="loss"              md-label="Убыл"           ) {{(item.loss == 1) ? 'Да' : 'Нет'}}
        //-     md-table-cell(md-sort-by="arrival_date"      md-label="Дата прибытия"  ) {{item.arrival_date}}
        //-     md-table-cell(md-sort-by="loss_date"         md-label="Дата убытия"    ) {{item.loss_date}}
        //-     md-table-cell(md-sort-by="created_at"        md-label="Дата записи"    ) {{item.created_at}}
        //-     md-table-cell(md-sort-by="updated_at"        md-label="Дата обновления") {{item.updated_at}}
</template>

<script>
  import moment from "moment";
  import StockMenu from './menu.vue';
  import SortTable from "@/components/SortTable";
  export default {
    components: {StockMenu, SortTable},
    data() {
      return {
        tableColumns: [
          { label: 'ID склада', field: 'id', default: true, sortable: true },
          { label: 'Склад', field: 'stock.name' },
          { label: 'Ответственный', field: 'responsible.login' },
          { label: 'Прибыл', field: 'arrival', sortable: true },
          { label: 'Убыл', field: 'loss', sortable: true },
          { label: 'Дата прибытия', field: 'arrival_date', sortable: true },
          { label: 'Дата убытия', field: 'loss_date', sortable: true },
          { label: 'Дата записи', field: 'created_at', sortable: true },
          { label: 'Дата обновления', field: 'updated_at' },
        ],
        title: 'Отслеживание груза',
        perPage: 25
      }
    },
    computed: {
      trackingAmount() {
        return this.$store.state.stock.tracking_amount
      },
      totalPages() {
        return Math.ceil(this.trackingAmount / this.perPage)
      },
      freight() {
        return this.$store.state.stock.freight
      },
      tracking() {
        if (typeof this.$store.state.stock.tracking != 'undefined') {
          this.$store.state.stock.tracking.forEach((tracking) => {
            tracking.arrival_date = (tracking.arrival_date) ? moment(tracking.arrival_date).format('DD.MM.YYYY HH:mm:ss') : '';
            tracking.loss_date    = (tracking.loss_date)    ? moment(tracking.loss_date).format('DD.MM.YYYY HH:mm:ss')    : '';
            tracking.created_at   = (tracking.created_at)   ? moment(tracking.created_at).format('DD.MM.YYYY HH:mm:ss')   : '';
            tracking.updated_at   = (tracking.updated_at)   ? moment(tracking.updated_at).format('DD.MM.YYYY HH:mm:ss')   : '';
          })

          return this.$store.state.stock.tracking
        }

        return []
      }
    },
    created() {
      this.$store.dispatch('stock/getFreight', this.$route.params.freight_id);
    },
    methods: {
      getFreights() {
        this.$store.dispatch('stock/getFreights')
      },
      getFreightTracking(page, count, orderBy, orderType) {
        this.$store.dispatch('stock/getFreightTracking', {
          filter: {model: [['freight_id', '=', this.$route.params.freight_id]], relation: []},
          page: page, order_by: orderBy, order_type: orderType, count: count
        });
      }
    }
  }
</script>
<style lang="sass">
  .freight-description
    padding: 0px 15px
  .action-container
    .md-table-cell-container
      display: flex
</style>



// WEBPACK FOOTER //
// FreightTracking.vue?04eedc7a